<div class="menu-indice">Gestión de Productos / Producto</div>
<mdb-card>
    <mdb-card-body>        
        <div class="form-row align-items-center">
            <div class="form-group col-md-4">
            <div class="md-form mt-0 mb-0">
                <input type="text" id="txtdescripcion" maxlength="100" [(ngModel)]="txtdescripcion" class="form-control" mdbInput>
                <label for="txtdescripcion">Producto</label>
            </div>
            </div>
            <div class="form-group col-md-2">
                Tipo de Regalo:
            </div>
            <div class="form-group col-md-2">
                    <select class="browser-default custom-select" [(ngModel)]="cboTipoRegalo">
                    <option value="" selected>Todos</option>
                    <option *ngFor="let tiporegalo of listTipoRegalo.response.list" [value]="tiporegalo.id">{{tiporegalo.name}}</option>
                    </select>
            </div>
            <div class="form-group col-md-2">
              Temática:
            </div>
            <div class="form-group col-md-2">
                    <select class="browser-default custom-select" [(ngModel)]="cboTematica">                  
                    <option value="" selected>Todos</option>
                    <option *ngFor="let listTopico of listTopico.response.list" [value]="listTopico.id">{{listTopico.name}}</option>
                    </select>
            </div>            
        </div>
        <div class="form-row align-items-center">
          <div class="form-group col-md-1">
            <span style="font-size: 15px;">Nov. Regalo:</span>
          </div>
          <div class="form-group col-md-2">
                  <select class="browser-default custom-select" [(ngModel)]="cboNovedades">                  
                  <option *ngFor="let novedades of listNovedades.response.list" [value]="novedades.masterValue">{{novedades.masterDescription}}</option>
                  </select>
          </div>
          <div class="form-group col-md-1">
            <span style="font-size: 15px;">Nov. Temática:</span>
          </div>
          <div class="form-group col-md-2">
                  <select class="browser-default custom-select" [(ngModel)]="cboNovedadesTopic">                  
                  <option *ngFor="let listNovedadesTopic of listNovedadesTopic.response.list" [value]="listNovedadesTopic.masterValue">{{listNovedadesTopic.masterDescription}}</option>
                  </select>
          </div>
          <div class="form-group col-md-1">
            Estado:
          </div>
          <div class="form-group col-md-2">
                  <select class="browser-default custom-select" [(ngModel)]="cboEstado">
                  <option value="" selected>Todos</option>
                  <option *ngFor="let estado of listEstado.response.list" [value]="estado.masterName">{{estado.masterDescription}}</option>
                  </select>
          </div>
          <div class="form-group col-md-3 d-flex justify-content-center">
            <button mdbBtn type="button" id="btnBuscar" (click)="onBuscar()" size="sm" color="deep-purple" mdbWavesEffect>
            <mdb-icon fas icon="search" class="mr-1"></mdb-icon>Buscar</button>                              
            <button mdbBtn type="button" id="btnNuevo" (click)="onNuevo('0')" size="sm" color="deep-purple" mdbWavesEffect>
            <mdb-icon fas icon="plus-square" class="mr-1"></mdb-icon>Nuevo</button>
          </div>
        </div>
    </mdb-card-body>
  </mdb-card>
  <br/>
  <div class="row">
    <div class="col-md-10" style="text-align: left;padding-bottom: 5px;font-weight: 500;font-size: 13px;">Total : {{listProducto.response.list.length}}</div>
    <div class="col-md-2" style="text-align: end;"> <a (click)="onExportarExcel()" style="text-align: right;font-weight: 500;font-size: 13px;">Exportar <mdb-icon far icon="file-excel" class="indigo-text" size="lg" aria-hidden="true"></mdb-icon></a></div>
  </div>  
  <mdb-card>
      <div class="table-responsive">
        <table mdbTable hover="true">
          <thead>
            <tr>
              <th *ngFor="let head of headElements" scope="col">{{head}}</th>
            </tr>
          </thead>
          <tbody>
            <tr mdbTableCol *ngFor="let listProducto of listProducto.response.list | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
              <td style="width: 200px;">{{listProducto.title}}</td>
              <td>{{listProducto.groupName}}</td>
              <td>{{listProducto.submenuName}}</td>
              <td>{{listProducto.order}}</td>
              <td style="text-align: center;"><mdb-checkbox [checked]="listProducto.novelty== '1'? true: false" class="check-input" [disabled]="true"></mdb-checkbox></td>
              <td style="text-align: center;"><mdb-checkbox [checked]="listProducto.topicNovelty== '1'? true: false" class="check-input" [disabled]="true"></mdb-checkbox></td>
              <td>{{listProducto.status}}</td>
              <td><button type="button" (click)="onEditar(listProducto.id)" color="deep-purple" outline="true" class="btn-sm" mdbWavesEffect mdbBtn><mdb-icon fas icon="book" size="lg"></mdb-icon></button></td>            
            </tr>
          </tbody>
        </table>
      </div>
        <div class="text-center">
          
          <ngb-pagination [maxSize]=3 [(page)]="page" class="d-flex justify-content-center"
            [pageSize]="pageSize" [boundaryLinks]="true" [collectionSize]="listProducto.response.list.length">
          </ngb-pagination>
          
        </div>
            
  </mdb-card>
<br>
